<app-basic-form [form]="form" [keys]="formKeys"></app-basic-form>
<ng-container *ngIf="showFunds">
    <app-assets-table [assets]="funds" [form]="form" [tableKeys]="tableKeys" [isReadOnly]="isReadOnly" (emitFunds)="readFunds($event)"></app-assets-table>
</ng-container>
<ng-container *ngIf="showAssets && !showFunds">
    <app-assets-table [assets]="assets" [form]="form" [tableKeys]="tableKeys" [isReadOnly]="isReadOnly"></app-assets-table>
</ng-container>